module.exports = __webpack_public_path__ + "static/img/xxpl_xxpl.326126e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xxpl_xxpl.png
// module id = PD7G
// module chunks = 0